import { lazy } from 'react';
import { Outlet } from 'react-router-dom';
import {
	VIDEO_UPLOAD,
	FLOOR_PLAN,
	USER_LIST,
	DASHBOARD,
	ADMIN_FAQ,
	ADMIN_EVENTS,
	ADMIN_LIBRARY,
	ADMIN_SALAQEEN,
	ADMIN_FAQ_CATEGORY,
	ADMIN_VIDEO_UPLOAD_CATEGORY,
	ADMIN_CONTACT,
	AUDIO_UPLOAD,
	CREATE_FLOOR_PLAN,
	VIEW_FLOOR_PLAN,
	ITIKAAF_APPROVED_LIST,
	ITIKAAF_CONFIRMED_LIST,
	MASJID_LIST,
	VIEW_USER_FLOOR_PLAN,
	ITIKAAF_ASSIGNED_LIST,
	ITIKAAF_ASSIGNED_SEATS_LIST,
	ITIKAAF_ASSIGNED_SEATS,
	ADMIN_USERS,
	ADMIN_USER_LOGS,
	ITIKAAF_REJECTED_LIST,
	DYNAMIC_QR_SCANNER,
	EDIT_FLOOR_PLAN,
	ADMIN_ERROR_LOGS,
	ADMIN_QR_EVENT_MANAGEMENT,
	ADMIN_QR_EVENT_LOGS,
	ADMIN_REGISTERED_USERS,
	ADMIN_VISITORS,
	VISITOR_QR_SCANNER,
	ITIKAAF_EVENTS,
	ITIKAAF_EVENTS_CREATE,
	ITIKAAF_EVENTS_VIEW,
	ITIKAAF_EVENTS_EDIT,
} from '../config/constants/routePathConstants';
import CreateFloorPlan from '../pages/adminContainer/floor-plan/CreateFloorPlan';
import EditFloorPlan from '../pages/adminContainer/floor-plan/EditFloorPlan';
import ViewFloorPlan from '../pages/adminContainer/floor-plan/ViewFloorPlan';
import ViewUserFloorPlan from '../pages/adminContainer/user-list/ViewUserFloorPlan';
import ItikaafApprovedList from '../pages/adminContainer/user-list/ItikaafApprovedList';
import ItikaafConfirmedList from '../pages/adminContainer/user-list/ItikaafConfirmedList';
import ItikaafAssignedList from '../pages/adminContainer/user-list/ItikaafAssignedList';
import MasjidList from '../pages/adminContainer/user-list/MasjidList';
import ItikaafAssignedFloor from '../pages/adminContainer/itikaaf-assigned-floor/ItikaafAssignedFloor';
import ItikaafAssignedFloorList from '../pages/adminContainer/itikaaf-assigned-floor';
import ItikaafRejectedList from '../pages/adminContainer/user-list/ItikaafRejectedList';
import DynamicQrScanner from '../pages/adminContainer/user-list/dynamicQrScanner';
import QrEventManagement from '../pages/adminContainer/user-list/qrEventManagement';
import ErrorLogsList from '../pages/adminContainer/server-error-logs';
import QrEventLogsList from '../pages/adminContainer/qr-event-logs';

const DashBoard = lazy(() => import('../pages/adminContainer/dashboard'));
const ManageAdminUsers = lazy(() =>
	import('../pages/adminContainer/manage-admin-users'),
);
const UserLogs = lazy(() => import('../pages/adminContainer/user-logs'));
const VideoUpload = lazy(() => import('../pages/adminContainer/video-upload'));
const AudioUpload = lazy(() => import('../pages/adminContainer/audio-upload'));
const VideoUploadCategory = lazy(() =>
	import('../pages/adminContainer/video-upload/category'),
);
const FloorPlan = lazy(() => import('../pages/adminContainer/floor-plan'));
const UserList = lazy(() => import('../pages/adminContainer/user-list'));
const AdminEvents = lazy(() => import('../pages/adminContainer/admin-events'));
const AdminContact = lazy(() =>
	import('../pages/adminContainer/admin-contact'),
);
const AdminFaq = lazy(() => import('../pages/adminContainer/admin-faq'));
const AdminFaqCategory = lazy(() =>
	import('../pages/adminContainer/admin-faq-category'),
);
const AdminLibrary = lazy(() =>
	import('../pages/adminContainer/admin-library'),
);
const AdminSalaqeen = lazy(() =>
	import('../pages/adminContainer/admin-salaqeen'),
);
const RegisteredUsersList = lazy(() =>
	import('../pages/adminContainer/admin-registered-users'),
);
const VisitorList = lazy(() => import('../pages/adminContainer/visitor-list'));
const VisitorQRScanner = lazy(() =>
	import('../pages/adminContainer/visitor-qr-scanner'),
);
const EventList = lazy(() =>
	import('../pages/adminContainer/itikaaf-events/EventList'),
);
const ViewEvent = lazy(() =>
	import('../pages/adminContainer/itikaaf-events/ViewEvent'),
);
const CreateEvent = lazy(() =>
	import('../pages/adminContainer/itikaaf-events/CreateEvent'),
);
const EditEvent = lazy(() =>
	import('../pages/adminContainer/itikaaf-events/EditEvent'),
);
const NotFound = lazy(() => import('../pages/websiteContainer/notFound'));

const adminRoutes = [
	{
		path: '/',
		element: <Outlet />,
		children: [
			{
				index: true,
				element: <DashBoard />,
			},
			{
				path: DASHBOARD,
				element: <DashBoard />,
			},
			{
				path: VIDEO_UPLOAD,
				element: <VideoUpload />,
			},
			{
				path: AUDIO_UPLOAD,
				element: <AudioUpload />,
			},
			{
				path: ADMIN_VIDEO_UPLOAD_CATEGORY,
				element: <VideoUploadCategory />,
			},
			{
				path: FLOOR_PLAN,
				element: <FloorPlan />,
			},
			{
				path: `${MASJID_LIST}/:city/:id`,
				element: <MasjidList />,
			},
			{
				path: CREATE_FLOOR_PLAN,
				element: <CreateFloorPlan />,
			},
			{
				path: EDIT_FLOOR_PLAN,
				element: <EditFloorPlan />,
			},
			{
				path: VIEW_FLOOR_PLAN,
				element: <ViewFloorPlan />,
			},
			{
				path: VIEW_USER_FLOOR_PLAN,
				element: <ViewUserFloorPlan />,
			},
			{
				path: ITIKAAF_EVENTS,
				element: <EventList />
			},
			{
				path: ITIKAAF_EVENTS_CREATE,
				element: <CreateEvent />,
			},
			{
				path: ITIKAAF_EVENTS_VIEW,
				element: <ViewEvent />,
			},
			{
				path: ITIKAAF_EVENTS_EDIT,
				element: <EditEvent />,
			},
			{
				path: ITIKAAF_ASSIGNED_SEATS_LIST,
				element: <ItikaafAssignedFloorList />,
			},
			{
				path: ITIKAAF_ASSIGNED_SEATS,
				element: <ItikaafAssignedFloor />,
			},
			{
				path: USER_LIST,
				element: <UserList />,
			},
			{
				path: ITIKAAF_APPROVED_LIST,
				element: <ItikaafApprovedList />,
			},
			{
				path: ITIKAAF_REJECTED_LIST,
				element: <ItikaafRejectedList />,
			},
			{
				path: DYNAMIC_QR_SCANNER,
				element: <DynamicQrScanner />,
			},
			{
				path: ITIKAAF_ASSIGNED_LIST,
				element: <ItikaafAssignedList />,
			},
			{
				path: ITIKAAF_CONFIRMED_LIST,
				element: <ItikaafConfirmedList />,
			},
			{
				path: ADMIN_CONTACT,
				element: <AdminContact />,
			},
			{
				path: ADMIN_EVENTS,
				element: <AdminEvents />,
			},
			{
				path: ADMIN_FAQ,
				element: <AdminFaq />,
			},
			{
				path: ADMIN_FAQ_CATEGORY,
				element: <AdminFaqCategory />,
			},
			{
				path: ADMIN_LIBRARY,
				element: <AdminLibrary />,
			},
			{
				path: ADMIN_SALAQEEN,
				element: <AdminSalaqeen />,
			},
			{
				path: ADMIN_VISITORS,
				element: <VisitorList />,
			},
			{
				path: VISITOR_QR_SCANNER,
				element: <VisitorQRScanner />,
			},
			{
				path: ADMIN_USERS,
				element: <ManageAdminUsers />,
			},
			{
				path: ADMIN_USER_LOGS,
				element: <UserLogs />,
			},
			{
				path: ADMIN_QR_EVENT_MANAGEMENT,
				element: <QrEventManagement />,
			},
			{
				path: ADMIN_ERROR_LOGS,
				element: <ErrorLogsList />,
			},
			{
				path: ADMIN_QR_EVENT_LOGS,
				element: <QrEventLogsList />,
			},
			{
				path: ADMIN_REGISTERED_USERS,
				element: <RegisteredUsersList />,
			},
			{
				path: '*',
				element: <NotFound />,
			},
		],
	},
];

export default adminRoutes;
